import {ToPartialMatchOptions} from 'Shared/utilities/MapDiscriminatedUnion';

export class InvalidOrdinaryAccidentNewYork {
  public readonly key = 'InvalidOrdinaryAccidentNewYork';
}

export class ValidOrdinaryAccidentNewYork {
  public readonly key = 'ValidOrdinaryAccidentNewYork';
}

export type OrdinaryAccidentNewYork = InvalidOrdinaryAccidentNewYork | ValidOrdinaryAccidentNewYork;

export type OrdinaryAccidentNewYorkOptions<TReturn> = ToPartialMatchOptions<OrdinaryAccidentNewYork, 'key', TReturn>;

export const matchOrdinaryAccidentNewYork = <TReturn>(options: OrdinaryAccidentNewYorkOptions<TReturn>) => (
  app: OrdinaryAccidentNewYork
): TReturn => {
  switch (app.key) {
    case 'InvalidOrdinaryAccidentNewYork':
      return options.InvalidOrdinaryAccidentNewYork
        ? options.InvalidOrdinaryAccidentNewYork(app)
        : options.default(app);
    case 'ValidOrdinaryAccidentNewYork':
      return options.ValidOrdinaryAccidentNewYork ? options.ValidOrdinaryAccidentNewYork(app) : options.default(app);
  }
};

export const EmptyOrdinaryAccidentNewYork = new InvalidOrdinaryAccidentNewYork();
